import React from 'react';
import { Card } from 'react-bootstrap';
import ContactUsForm from './ContactUsForm';

export default function ContactUs() {
  return (
    <>
      <Card className="h-100 mt-3">
        <Card.Header className="bg-light btn-reveal-trigger d-flex flex-between-center">
          <h5 className="mb-0">Contact Us</h5>
        </Card.Header>
        <Card.Body>
          <ContactUsForm />
        </Card.Body>
      </Card>
    </>
  );
}
